export default function formatCancellationSignalName(chatId: string): string {
  return `copilot-cancellation-complete-${chatId}`;
}
